import { axiosInstance } from './request';
import { cfg } from '../config/config';

const apiUrl = `${cfg.apiUrl}/api/accounts`;

export const markAssetAsIgnored = (accId: string, assetId: string) => {
  return axiosInstance.put(`${apiUrl}/${accId}/assets/${assetId}/ignore`);
};
